const AUTO_CLOSE_TIMEOUT = 10000

// It's possible to accept messages as one message or array of messages
// By default parrentElement is element with #flash_message_container id

const notify = ({message, status, parentElement = document.getElementById("flash_message_container")}) => {
  if (!parentElement && !message && !status) return 
  if (isThereAlreadySameNotice(message, status)) return

  if(Array.isArray(message)){
    message.forEach(element => {
      appendFlashMessage({message: element, status, parentElement})      
    });
  }else{
    appendFlashMessage({message, status, parentElement})
  }
}

function isThereAlreadySameNotice(message, status){
  const notifyClass = getNotifyStyle(status)
  if (!notifyClass || notifyClass.length == 0) return false
  const className = notifyClass.join(" ")
  let item = document.getElementsByClassName(className)
  if (!item || item.length == 0 ) return false
  item = item[0]
  if (item.innerText === message) return true
  return false
}

function appendFlashMessage({message, status, parentElement}){
  const notifyElement = generateNotify({message, status})
  
  parentElement.appendChild(notifyElement)
}

function generateNotify({message, status}){
  const notifyClass = getNotifyStyle(status)
  const iconClass = getIconStyle(status) 
  
  // Configure notify element
  const notifyElement = document.createElement('div')
  notifyElement.classList.add(...notifyClass)

  // Add button element to notify
  notifyElement.appendChild(createCloseButton()) 

  // Configure icon element
  const iconElement = document.createElement('i')
  iconElement.classList.add(...iconClass)
  notifyElement.append(iconElement)

  // Add text to notify
  const wrapperText = document.createElement('span')
  wrapperText.innerHTML = message
  notifyElement.appendChild(wrapperText)

  // Auto close alert
  setTimeout(function () {
      $(notifyElement).alert('close');
  }, AUTO_CLOSE_TIMEOUT);

  return notifyElement
}

// Create close button icon
function createCloseButton(){
  const closeButton = document.createElement('button')
  closeButton.setAttribute('type', 'button')
  closeButton.setAttribute('data-dismiss', 'alert')
  closeButton.classList.add('close')

  const iconButton = document.createElement('span')
  iconButton.classList.add('fas', 'fa-times')

  closeButton.appendChild(iconButton)

  return closeButton
}


function getIconStyle(status){
  const generalStyle = ['far', 'mr-1']
  switch (status) {
    case 'alert':
      return [...generalStyle, 'fa-exclamation-triangle']
    case 'success':
      return [...generalStyle, 'fa-check-circle']
    case 'error':
      return [...generalStyle, 'fa-times-circle'] 
    default:
      return ''
  }
}

function getNotifyStyle(status){
  switch (status) {
    case 'alert':
      return ['alert', 'alert-warning']
    case 'success':
      return ['alert', 'alert-success'] 
    case 'error':
      return ['alert', 'alert-danger'] 
    default:
      return ''
  }
}

export default notify